/**
 * Adds the selected gift bag variant together with the main product on add to cart.
 * Also includes shop-the-look items when both add-ons are present on the same form.
 */
(function () {
  if (window.__giftBagInit) {
    return;
  }

  window.__giftBagInit = true;

  function getMainVariantId(form) {
    var variantInput = form.querySelector('[name="id"]');
    return variantInput ? variantInput.value : null;
  }

  function getFormQuantity(form) {
    var quantityInput = form.querySelector('[name="quantity"]');
    return Math.max(1, parseInt(quantityInput && quantityInput.value ? quantityInput.value : '1', 10) || 1);
  }

  function getGiftBagRoot(form) {
    return form.querySelector('[data-gift-bag]');
  }

  function isGiftBagSelected(root) {
    var checkbox = root && root.querySelector('[data-gift-bag-checkbox]');
    return Boolean(checkbox && checkbox.checked && !checkbox.disabled);
  }

  function getShopTheLookItems(form) {
    var items = [];
    var container = form.querySelector('[data-shop-the-look]');

    if (!container) {
      return items;
    }

    container.querySelectorAll('[data-shop-the-look-item]').forEach(function (card) {
      var checkbox = card.querySelector('[data-shop-the-look-checkbox]');
      var variantField = card.querySelector('[data-shop-the-look-variant]');
      var variantId = variantField ? variantField.value : null;

      if (checkbox && checkbox.checked && variantId) {
        items.push({
          id: parseInt(variantId, 10),
          quantity: 1
        });
      }
    });

    return items;
  }

  function showError(button, message) {
    var existingError = button.parentElement.querySelector('.ProductForm__Error');

    if (existingError) {
      existingError.remove();
    }

    var errorMessageElement = document.createElement('span');
    errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
    errorMessageElement.innerHTML = message;
    button.removeAttribute('disabled');
    button.insertAdjacentElement('afterend', errorMessageElement);

    setTimeout(function () {
      errorMessageElement.remove();
    }, 5000);
  }

  function setGiftBagState(root, selected) {
    var checkbox = root.querySelector('[data-gift-bag-checkbox]');
    var toggle = root.querySelector('[data-gift-bag-toggle]');

    if (checkbox) {
      checkbox.checked = selected;
    }

    root.classList.toggle('is-selected', selected);

    if (toggle) {
      toggle.setAttribute('aria-pressed', selected ? 'true' : 'false');
    }
  }

  function cartHasVariant(cart, variantId) {
    return (cart.items || []).some(function (item) {
      return Number(item.variant_id) === variantId || Number(item.id) === variantId;
    });
  }

  function buildGiftBagItem(root, form, cart) {
    if (!isGiftBagSelected(root)) {
      return null;
    }

    var variantId = parseInt(root.getAttribute('data-variant-id'), 10);

    if (!variantId) {
      return null;
    }

    var addOnce = root.getAttribute('data-add-mode') !== 'every';

    if (addOnce && cart && cartHasVariant(cart, variantId)) {
      return null;
    }

    var quantity = 1;

    if (root.getAttribute('data-match-quantity') === 'true') {
      quantity = getFormQuantity(form);
    }

    return {
      id: variantId,
      quantity: quantity
    };
  }

  function addToCart(button, form, items, quantity) {
    var root = getGiftBagRoot(form);
    var useAjaxCart = !root || root.getAttribute('data-use-ajax-cart') === 'true';

    button.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(window.routes.cartAddUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));

      if (response.ok) {
        button.removeAttribute('disabled');

        if (!useAjaxCart) {
          window.location.href = window.routes.cartUrl;
          return;
        }

        var productSection = form.closest('.Product') || form;

        productSection.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            quantity: quantity
          }
        }));
      } else {
        response.json().then(function (content) {
          showError(button, content.description || 'Add to cart failed');
        });
      }
    }).catch(function () {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      button.removeAttribute('disabled');
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-gift-bag-toggle]');

    if (!toggle) {
      return;
    }

    event.preventDefault();

    var root = toggle.closest('[data-gift-bag]');
    var checkbox = root && root.querySelector('[data-gift-bag-checkbox]');

    if (!checkbox) {
      return;
    }

    setGiftBagState(root, !checkbox.checked);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-action="add-to-cart"]');

    if (!button || button.disabled) {
      return;
    }

    var form = button.closest('form.ProductForm, form[action*="/cart/add"]');

    if (!form) {
      return;
    }

    var root = getGiftBagRoot(form);
    var lookItems = getShopTheLookItems(form);
    var giftSelected = isGiftBagSelected(root);

    if (!root || (!giftSelected && lookItems.length === 0)) {
      return;
    }

    var mainVariantId = getMainVariantId(form);

    if (!mainVariantId || !window.routes || !window.routes.cartAddUrl) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    var quantity = getFormQuantity(form);
    var needsCartCheck = giftSelected && root.getAttribute('data-add-mode') !== 'every';
    var cartPromise = needsCartCheck
      ? fetch(window.routes.cartUrl + '.js', { credentials: 'same-origin' }).then(function (response) {
        return response.json();
      }).catch(function () {
        return { items: [] };
      })
      : Promise.resolve({ items: [] });

    cartPromise.then(function (cart) {
      var giftItem = buildGiftBagItem(root, form, cart);
      var items = [{ id: parseInt(mainVariantId, 10), quantity: quantity }];

      if (giftItem) {
        items.push(giftItem);
      }

      items = items.concat(lookItems);
      addToCart(button, form, items, quantity);
    });
  }, true);
})();
